var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "caseVideo" },
    [
      _c("TopNavigation", { attrs: { TopAct: "1" } }),
      _c(
        "div",
        { class: this.$store.state.webNavigator == "pc" ? "" : "pan110" },
        [
          _c("listTopImg", { attrs: { imgType: "1" } }),
          _c(
            "div",
            {
              staticClass: "marginAuto",
              class: this.$store.state.webNavigator == "pc" ? "max1720" : ""
            },
            [
              _c("videoPage", {
                key: _vm.keys,
                attrs: {
                  listType: "A9",
                  titles: "案例视频",
                  active: _vm.types,
                  pageIndex: _vm.current,
                  navLsit: _vm.navList,
                  toLeveListPath: _vm.toLeveListPath
                },
                on: { getTotal: _vm.getTotal }
              })
            ],
            1
          ),
          _c("Pagination", {
            attrs: {
              total: _vm.total,
              display: 9,
              "current-page": _vm.current
            },
            on: { pagechange: _vm.getPage }
          })
        ],
        1
      ),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eaaee994", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaaee994","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/caseVideo/caseVideo.vue
// module id = 1187
// module chunks = 8